import React, { useContext, useEffect, useState } from "react";
import { useFailedUniOrders } from "./store";
import { Col, Row } from "react-bootstrap";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { UnicommerseProps } from "./uniCommerceContext";
import ExcelGenerator from "modules/convertToExcel/ExcelGenerator";
import { fourPlaceHolder } from "modules/utilities/utility";
const {
  default: AdvanceTable,
} = require("modules/common/advance-table/AdvanceTable");
const {
  default: AdvanceTableWrapper,
} = require("modules/common/advance-table/AdvanceTableWrapper");

const columns = [
  {
    accessor: "order_display_id",
    Header: "Order Display id",
    headerProps: { className: "text-900" },
  },
];

function BulAction(table) {
  const selectedRowIds = table.selectedRowIds;
  const selectedOrders = useContext(UnicommerseProps).selectedOrderID;
  let data = useContext(UnicommerseProps).setStateData;
  data(selectedRowIds);
  return (
    <>
      <Row className="flex-between-center mb-3">
        <Col xs={4} sm="auto" className="d-flex align-items-center pe-0">
          <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">
            {Object.keys(selectedRowIds).length > 0
              ? "Selected " + Object.keys(selectedRowIds).length + " rows"
              : "Failed Orders"}
          </h5>
        </Col>
        <Col xs={8} sm="auto" className="ms-auto text-end ps-0">
          <div className="d-flex">
            <ExcelGenerator
              selectedOrderDisplayIDs={selectedOrders}
              sheetName="FailedUniOrders"
              fileName="failed_uni_orders.xlsx"
            />
          </div>
        </Col>
      </Row>
    </>
  );
}

function AdvanceTableExample({ failedUniData }) {
  // const
  return (
    <AdvanceTableWrapper
      columns={columns}
      data={failedUniData}
      sortable
      pagination
      perPage={10}
      selection
      selectionColumnWidth={30}
    >
      <BulAction table />
      <AdvanceTable
        table
        headerClassName="bg-200 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          striped: true,
          className: "fs-10 mb-0 overflow-hidden",
        }}
      />
    </AdvanceTableWrapper>
    // </UnicommerseProps.Provider>
  );
}

function FailedUniOrdersTable() {
  const { failedUniData, validateLoading, getValidateData, postFailedData } =
    useFailedUniOrders();
  const [page, newPage] = useState(1);
  const [uniData, setUniData] = useState([]);
  const [setData, setStateData] = useState([]);
  const [selectedOrderID, setSelectedOrderID] = useState([]);

  useEffect(() => {
    getValidateData(page);
  }, [page]);

  useEffect(() => {
    setUniData(failedUniData);
  }, [failedUniData]);
  useEffect(() => {
    const selectedOrderDisplayIDs = Object.keys(setData)
      .filter((index) => setData[index])
      .map((index) => uniData.data[index].order_display_id);
    setSelectedOrderID(selectedOrderDisplayIDs);
  }, [setData]);
  const pageCount = failedUniData ? failedUniData?.pagination?.pageCount : 1;
  return (
    <>
      <h1>Failed Unicommerce Orders</h1>
      {uniData.data ? (
        <>
          <UnicommerseProps.Provider value={{ setStateData, selectedOrderID }}>
            <AdvanceTableExample
              failedUniData={uniData.data}
              setStateData={setStateData}
            />
            <PaginationDiv
              paginationData={{ pageCount: pageCount || 1, page: page }}
              newPage={newPage}
              activePage={page}
            />
          </UnicommerseProps.Provider>
        </>
      ) : fourPlaceHolder()}
    </>
  );
}

export default FailedUniOrdersTable;
